/** バブルを viewport 端から最低限離すマージン（px） */
export const VIEWPORT_MARGIN = 8;
/** バブルとトリガー間の余白（px）。styles.module.scss の translate(...) 内の 8px と対応 */
export const GAP = 8;

/** 矢印（&::after）の半幅。styles.module.scss の border-width: 6px と対応 */
export const ARROW_HALF_WIDTH = 6;
/** バブルの角丸半径。ui/layout/borderRadius.scss の borderRadius('sm') と対応 */
export const ARROW_CORNER_INSET = 4;

/**
 * アプリ内で共有される単一のツールチップバブルの id。
 * TooltipProvider が document.body 直下にマウントする 1 インスタンスを指すため、
 * トリガー要素側は aria-describedby={TOOLTIP_ID} で紐付ける。
 */
export const TOOLTIP_ID = 'shared-tooltip';
